module.exports = __webpack_public_path__ + "static/media/fixed-on-responsive-unit-icon.c28f465b.svg";